<template>
  <div id="domain-create-details-tab">
    <div class="vx-col w-full">
        <div class="vx-row ">
          <div class="vx-col lg:w-1/2 sm:w-1/1 w-full mb-2 ">
              <vs-input class="w-full" label-placeholder="Domain Name" v-model="data_local.domain_name" @change="domainUpdateData"/>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mb-2 ">
            <vs-select class="w-full mt-5" placeholder="Domain Status" v-model="data_local.status"  @change="domainUpdateData">
              <vs-select-item :key="index" :value="option" :text="option | capitalize" v-for="(option,index) in statusOptions"/>
            </vs-select>
          </div>
        </div>
      <div class="vx-row  mb-4">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Thumbnail URL" v-model="data_local.domain_thumbnail"/>
        </div>
      </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full mt-2">
            <vs-textarea  label="Domain Description" counter="400" :counter-danger.sync="domain_description_counter" height="100px" v-model="data_local.domain_description" @change="domainUpdateData"/>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="success" type="filled" class="mb-2 mr-2"
                       @click="submitData">Create Domain
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2 ml-2"
                       @click="resetData">Reset
            </vs-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      retailer_options: [],
      domain_description_counter: null,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ]

    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    domainUpdateData () {
      this.$emit('update_domainData', this.data_local)
    },
    submitData () {
      this.$emit('insert_domainData', this.data_local)
    },
    resetData () {
      this.data_local =  {domain_name: undefined, domain_description: undefined, domain_status: undefined, domain_code : undefined}
      this.domainUpdateData()
    }
  }
}
</script>

<style scoped>

</style>
